<template>
    <div>
<!--        <breadcrumb :flag="true"/>-->
      <Breadtabsheader/>
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<!-- cha -->
			<img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../assets/images/leaderBg.jpg" class="leaderbg">
			<!-- 第一步的图 -->
			<img src="../../assets/images/stepSecond.png" class="steps step1" v-if="status==1">
			<!-- 第二步的图 -->
			<img src="../../assets/images/stepFirst.png" class="steps step2" v-if="status==2">
			<!-- 第三步的图 -->
			<img src="../../assets/images/stepThird.png" class="steps step3" v-if="status==3">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"下一步":status==3?"我知道了":"我知道了"}}
			</div>
			<div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
        <div class="h-content">
            <div class="h-row" style="margin-top: 0;">
                <div class="h-rowIn" style="width: 61.5%;">
                    <div class="h-rowBox" style="height: 7.4rem;">
                        <div class="h-rowTitle">
                            <div class="h-disTable">
                                <div class="h-tableCell">
                                    <h1>我的日程</h1>
                                    <div class="h-calendarSelect">
                                        <div class="h-csBox">
                                            <el-select v-model="yearValue" placeholder="请选择"  @change="handleYearClick">
                                                <el-option
                                                        v-for="item in yearOptions"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                        <span class="h-selectLine">-</span>
                                        <div class="h-csBox">
                                            <el-select v-model="monthValue" placeholder="请选择" @change="handleMonthClick">
                                                <el-option
                                                        v-for="item in monthOptions"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </div>
                                    <div class="h-calenderSign">
                                        <span><i class="h-redBg"></i>超期</span>
                                        <span><i class="h-blueBg"></i>当前</span>
                                        <span><i class="h-greenBg"></i>提醒</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="h-rowCon">
                            <el-calendar v-model="calenderValue"  style="overflow:hidden;">
                                <template slot="dateCell" slot-scope="{date, data}">
                                    <div class="h-day" @click="handleDateClick(date)">
                                        <div style="height:0.9rem;;overflow:hidden;">
                                            <span class="h-dayNum" >
                                                {{data.day.split('-')[2].replace(/^0+/,'')}}
                                                <div v-for="(item,index) in calenderData" :key="index">
                                                    <i class='h-daySign h-redBg' v-if="$util.riQi3(ydate)>item.begindate.split(' ')[0]&&data.day==item.begindate.split(' ')[0]" ></i>
                                                    <i class='h-daySign h-greenBg' v-if="$util.riQi3(ydate)==item.begindate.split(' ')[0]&&data.day==item.begindate.split(' ')[0]" ></i>
                                                    <i class='h-daySign h-blueBg' v-if="$util.riQi3(tdate)==item.begindate.split(' ')[0]&&data.day==item.begindate.split(' ')[0]" ></i>
                                                </div>
                                            </span>
                                            <div style="padding-top:0.35rem;height:0.79rem;overflow:hidden;" @click="selecttime(data.day)">
                                                <div v-for="(item,index) in calenderData" :key="index" class="calenderdata" style="margin-bottom: 3.5px">
                                                    <div class="h-dataInfo"
                                                         v-if="data.day.split('-')[2].replace(/^0+/,'')==item.begindate.split(' ')[0].split('-')[2].replace(/^0+/,'')
                                                                && data.day.split('-')[1].replace(/^0+/,'')==item.begindate.split(' ')[0].split('-')[1].replace(/^0+/,'')">
                                                        <p>{{item.begindate.split(' ')[1].substr(0,5)}} {{item.name}}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-calendar>
                            <div class="planBoxzhezhao" v-if="planBoxlist">
                                <div class="planBoxs">
                                    <div class="planBoxtop">{{detailDayString}}</div>
                                    <div class="planBoxcenter">
                                        <div class="planBoxcenterlist" v-for="(item,index) in planlists" :key="index">
                                            <div class="divs">
                                                <div class="nullwan">未完成</div>
                                            </div>
                                            <div class="divs" :title="item.progressName">
                                                <el-tag class="ljj_tags h-label h-yellowLabel h-blueLabel h-fl" >{{item.progressName}}</el-tag>
                                            </div>
                                            <div class="divs">
                                                <div class="centertext" :title="item.name?item.name:''">{{item.name?item.name:''}}</div>
                                            </div>
                                            <div class="divs">
                                                <div class="timetext" :title="item.begindate">{{item.begindate.split(' ')[1]}}</div>
                                            </div>
                                            <div class="divs">
                                                <div class="editortext h-fr" @click="toShowOrComplate(item)">去处理</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="planBoxbottom">
                                        <div class="backtext" @click="planBoxlist=false">返回</div>
                                        <div class="h-pagination fenyes">
                                            <paginationmincopy :page="q1" @query="selecttimeQ(detailDayString)" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-----------------------代办start-->
                <tasklist divheight="7.4rem" :pagesize="10"/>
                <!-----end-->
            </div>
        </div>
      <div>
        <el-dialog :visible.sync="dialogFormVisible" class="h-dialog2" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
          <div class="h-dialogImg">
            <div class="h-disTable">
              <div class="h-tableCell">
                <h1>系统消息详情</h1>
              </div>
            </div>
          </div>
          <div class="h-formLine">
            <el-form ref="form"
                     :inline="true" class="demo-ruleForm h-formbLine h-dialogForm yhxxfj">
              <el-form-item label="消息" class="h-elformWrap-1" style="width: 100%;">
                <el-input  style="width: 100%;" :disabled="true" v-html="messageDetail" v-model="messageDetail"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <!-- <el-button class="h-btn h-bBtn h-bgblue" @click="goBack">返回</el-button> -->
            <el-button class="h-btn h-bgblue" @click="goBack">我知道了</el-button>
<!--            <el-button v-if="this.userIt == this.userNow" class="h-btn h-formBtn h-bgred" @click="del(idIt)">删除</el-button>-->
          </div>
        </el-dialog>
      </div>

    </div>
</template>

<script>
    import tasklist from '@/components/task/mytask.vue';
    import ss from '../../api/SystemService'
    export default {
        components:{
            tasklist
        },
        data() {
            return {
				// toshow:'Home',
				toshow:'Home1',
				status:1,
				showOrhide:false,
        dialogFormVisible:false,
                msgAgent:false,
        messageDetail:'',
              infoid:'',
				checked:true,
                calenderData:[],
                calenderValue:new Date(),
                tdate: new Date(),
                tdatestr: '',
                ydate: '',
                year:"",
                month:"",
                planBoxlist:false,
                yearOptions:[{
                    value:'2019',
                    label:'2019年'
                },{
                    value:'2020',
                    label:'2020年'
                }, {
                  value: '2021',
                  label: '2021年'
                }, {
                  value: '2022',
                  label: '2022年'
                }, {
                  value: '2023',
                  label: '2023年'
                }, {
                  value: '2024',
                  label: '2024年'
                }, {
                  value: '2025',
                  label: '2025年'
                }, {
                  value: '2026',
                  label: '2026年'
                }, {
                  value: '2027',
                  label: '2027年'
                }, {
                  value: '2028',
                  label: '2028年'
                }, {
                  value: '2029',
                  label: '2029年'
                }
                ],
                monthOptions:[{
                    value:'1',
                    label:'1月'
                },{
                    value:'2',
                    label:'2月'
                },{
                    value:'3',
                    label:'3月'
                },{
                    value:'4',
                    label:'4月'
                },{
                    value:'5',
                    label:'5月'
                },{
                    value:'6',
                    label:'6月'
                },{
                    value:'7',
                    label:'7月'
                },{
                    value:'8',
                    label:'8月'
                },{
                    value:'9',
                    label:'9月'
                },{
                    value:'10',
                    label:'10月'
                },{
                    value:'11',
                    label:'11月'
                },{
                    value:'12',
                    label:'12月'
                }],
                yearValue:new Date().getFullYear()+"年",//生成当前年
                monthValue:new Date().getMonth()+1+"月",//生成当前月
                //表单
                q: {
                    pageSize: 8,
                    pageNo: 1,
                    total: 0,
                },
              pageParams:{
                // pageSize:10,
                // pageNo:1,
                // total:0,
                announcement: 0,
                title : 'top用户批量导入驳回通知',
                isChecked: 0,
                // isChecked: 0,

              },
                //表单上面日历点击后页面
                q1: {
                    pageSize: 5,
                    pageNo: 1,
                    total: 0,
                },
                planlists:[
                    {
                        active:0,
                        title:'青岛大学附属医院血液柜拜访',
                        baifang:'常规拜访',
                        time:'11:30~12:30',
                    }
                ],
            }
        },
		mounted(){

		},
        methods: {
			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
			nextStep(i){
				if(this.status ==1){
					this.status = 2;
				}else if(this.status ==2){
					this.status = 3;
				}else if(this.status ==3){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})

					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}
			},
			closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}

			},
          //已读后打标志、并查询查询
          goBack() {
            this.dialogFormVisible = false;
            this.$store.dispatch('selectChecked',this.infoid).then(res => {
              this.infoid = '';
              if(res.f){
                this.showIsbohuitop();
              }
            });
          },
          //初始化加载查看是否有符合要求数据
           showIsbohuitop(){
             // this.$store.dispatch('searchMsgPage',this.pageParams).then(res=>{
             this.$store.dispatch('searchMsgTopList',this.pageParams).then(res=>{
              if(res.length>0){
                console.log(res,"data");
                this.dialogFormVisible = true;
                console.log(this.dialogFormVisible,"this.dialogFormVisible");
                this.messageDetail = res[0].text;
                this.infoid =  res[0].infoId;
                // console.log(res.records,"res.records");
                // console.log(this.messageDetail,"this.messageDetail");
              }
            })
          },
            queryAgenda() {
                ss.UserCare.allplan({
                    year: this.yearValue.split("年")[0],
                    month: this.monthValue.split("月")[0]
                }).then(rd => {
                    this.calenderData = rd.plans;
                    console.log(this.calenderData, "日程");
                })
            },
            searchTodoList(){
                ss.taskservice.searchMyUndoTask({
                    year: this.yearValue.split("年")[0],
                    month: this.monthValue.split("月")[0]
                }).then(rd=>{
                    //this.query.total = rd.total;
                    this.calenderData = rd.obj;
                    console.log(this.calenderData, "日程");
                })
            },
            handleYearClick(){
                this.calenderValue = (this.yearValue+"-"+this.monthValue).split("月")[0];
                this.searchTodoList();
            },
            handleMonthClick(){
                this.calenderValue = this.yearValue.split("年")[0]+"-"+this.monthValue;
                this.searchTodoList();
            },
            handleDateClick(a){
                this.yearValue = a.getFullYear()+"年";
                this.monthValue = a.getMonth()+1+"月";
                //this.searchTodoList();
            },
            //日历点击这个时间，日历点击那天的时间
            selecttime(times){
                console.log("times:"+times);
                this.q1.pageNo = 1;
                this.selecttimeQ(times);
            },
            //翻页
            selecttimeQ(times){
                // console.log(this.$util.riQi3(this.tdate))
                this.detailDayString=times;
                //交互计划详情\
                this.q1.tdatestr=times;
                ss.taskservice.searchMyUndoTaskPage(this.q1).then(rd => {
                    console.log(rd,"左面表格");
                    this.q1.total = rd.total;
                    this.planlists = rd.records;

                })
                this.planBoxlist = true;
            },
            toShowOrComplate(r){
                this.$router.push({path: r.dburl,query: {taskid:r.id,ywid:r.ywid,instid:r.instid,taskstatus:r.status}})
            },
            showTixing(){
                let txFlag = JSON.parse(sessionStorage.getItem("showSalesTixing"));
                console.log("showSalesTixing",txFlag);
                if(null == txFlag){
                    ss.fanli.showAgentSalesTixing().then(rd => {
                        if(rd.f){
                            this.$alert(rd.msg.message, '返利实际与目标差额提示', {
                                confirmButtonText: '确定',
                                type:'warning',
                                dangerouslyUseHTMLString:true,
                                customClass:'message_box_alert',
                                callback: action => {
                                    ss.fanli.remindedAgentSalesTixing(rd.msg.id);
                                    this.$message({
                                        type: 'info',
                                        message: '您可以点击右上角消息中心再次查看实际与目标的差额'
                                    });
                                }
                            });
                        }
                    });
                    //设为不提醒
                    txFlag = 'false';
                    sessionStorage.setItem("showSalesTixing",txFlag);
                }
            },
            //it服务台通知 没人只通知一次
            showITService(){
                // 提示通知
                let val = localStorage.getItem("showITService1");
                val = JSON.parse(val);
                console.log("123123",val);
                //如果缓存有效并且未过期
                if(val==null||val=='true'){
                    //这里再对数据库进行校验 防止缓存被清除
                    this.$alert("   为提升系统运维服务，量化系统运维质量，OMS运维已启用IT服务台，大家有问题请通过IT服务台提交，运维人员优先解决IT服务台提交的问题，谢谢！</br>IT服务器台路径：系统右下角，点击“IT服务台”图标", 'OMS系统运维启用IT服务台通知', {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                        type:'warning',
                    });
                    //将缓存置为无效
                    val = 'false';
                    console.log("JSON.stringify(val)",JSON.stringify(val))
                    localStorage.setItem("showITService1", JSON.stringify(val));
                }
            },

            //系统维护通知
            showMaintain(){
                // 提示通知
                let val = localStorage.getItem("showNotifyMain");
                 val = JSON.parse(val);
                 console.log(val, "缓存main");
                console.log(val, "缓存login");

                //如果是经销商
                if(this._user.usertype == '1' || this.msgAgent){
                    //如果缓存有效并且未过期
                    if(val.showNotify||val.showNotify=='true'){

                        const aLiUrl = require("../../assets/images/agengtmsg.png")

                        if (Date.now()/1000/60/60 - val.time/1000/60/60 < val.expire) {
                            this.$alert("<strong><img src="+ aLiUrl + ">", '系统通知', {
                                confirmButtonText: '确定',
                                dangerouslyUseHTMLString: true,
                                customClass: 'big-image-alert', // 添加自定义类
                            });

                            //将缓存置为无效
                            val.showNotify = false;
                            //localStorage 设置的值不能为对象,转为json字符串
                            localStorage.setItem("showNotifyMain", JSON.stringify(val));
                        }
                    }
                }
            },




        },

             created(){
               //查询是否有top用户被驳回
                 this.showIsbohuitop();
               // this.messageDetail = data.text
                 var dateTime=new Date();
                 this.ydate = new Date(dateTime.setDate(this.tdate.getDate()-1));
                 this.tdatestr=this.$util.riQi3(this.tdate);
                 this.searchTodoList();
                 this.msgAgent = this.$store.getters.hasRole('swyl_daqujl,swyl_quyujl,SHICHANG_PINGTAI,swyl_caiwujl');
                 this.showzhezhao();
                 //返利在签经销商实际目标差额提醒弹框
                 this.showTixing();
                 //IT服务台通知
                 this.showITService();
                 // 提示通知
                 this.showMaintain();

                /* val = JSON.parse(val);
                 console.log(val, "缓存main");
                 //如果缓存有效并且未过期
                 if(val.showNotify||val.showNotify=='true'){
                     if (Date.now()/1000/60/60 - val.time/1000/60/60 < val.expire) {
                          this.$alert("各位用户，运维邮箱已调整成yuanhangyl@yuanh.com.cn,有问题请发送邮件", '系统提示', {
                               confirmButtonText: '确定',
                              type:'warning',
                          });
                        /!* this.$alert("系统将于2021年4月28号19点至21点进行升级，请勿进行操作，避免数据丢失！届时将影响用户体验，敬请谅解!", '系统通知', {
                             confirmButtonText: '确定',
                             type:'warning',
                         });*!/
                         //将缓存置为无效
                         val.showNotify = false;
                         //localStorage 设置的值不能为对象,转为json字符串
                         localStorage.setItem("showNotifyMain", JSON.stringify(val));
                     }
                 }
     */

            // this.customerOptions();
            // this.agentOptions();
            // this.options2 = this.$store.getters.dicts["userCareType"];
        }
    }
</script>
<style scoped lang="scss">


	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
	.leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.6);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.steps{
			position: absolute;
			z-index: 1;

		}
		.step1{
			top: 0.69rem;
			left: 0;
			width: 5.22rem;
			height: 12.89rem;
		}
		.step2{
			top: 2.6rem;
			right: 0.38rem;
			width: 8.95rem;
			height: 7.16rem;
		}
		.step3{
			width: 1.95rem;
			height: 1.7rem;
			right: 1.5rem;
			top: 0.1rem;
		}
		.stepbtn{
			width: 1.8rem;
			height: 0.5rem;
			border: 0.01rem solid #FFFFFF;
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.24rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
    .selecBox{
        display: flex;
    }
    .selecBox .button{
        width: 85px;
        height: 32px;
        color: #767676;
        text-align: center;
        line-height: 28px;
        border:1px solid #dddfe4;
        background: #fff;
        cursor: pointer;
        font-size: 0.16rem;
    }
    .selecBox .button.active{
        background: #2686e7;
        color: #fff;
        border-color: #2686e7;
    }
    .textBox{
        margin-top: 20px;
        margin-left: 20px;
    }
    .textBox span{
        color: #bec3c4;
        font-size: 16px;
        margin-left: 30px;
    }
    .textBox span:first-child{
        margin: 0;
    }
	.bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}

</style>
<style>
    .h-tableCell .el-input__inner {
        width: 1.3rem;
        color: #DCDFE6;
        border-radius: 0;
        height: 0.32rem;
        line-height: 0.28rem;
        border: 1px solid #DCDFE6;
        font-size: 0.16rem;
        padding-right: 0.3rem;
        padding-left: 0.15rem;
    }
    .h-tableCell .el-input__icon{
        line-height: 0;
    }
    .fenyes .h-pagiLabel{
        display: none;
    }
    .fenyes .el-pagination .el-pagination__sizes{
        display: none;
    }

    .planBoxzhezhao{
        width: 100%;
        height: 6.3rem;
        background: rgba(0, 0, 0, 0.3);
        position: absolute;
        top: 10px;
        left: 0;
        box-sizing: border-box;
    }
    .planBoxs{
        width: 90%;
        height: 90%;
        background: #fff;
        border: 1px solid #c4c4c4;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        padding: 40px 40px 20px 40px;
        box-sizing: border-box;
    }
    .planBoxs .planBoxtop{
        font-size: 18px;
        color: #282828;
    }
    .planBoxs .planBoxcenter{
        margin-top: 10px;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 60px;
        border-bottom: 1px solid #eee;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist .divs{
        width: 16.666%;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        text-align: center;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist .yellowtext{
        width: 61px;
        height: 29px;
        background-color: #fbdfc8;
        border-radius: 15px;
        font-size: 14px;
        color: #ee9433;
        text-align: center;
        line-height: 29px;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist .centertext{
        font-size: 14px;
        color: #323232;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist .baifantext{
        font-size: 14px;
        color: #a7a7a7;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist .timetext{
        font-size: 14px;
        color: #a7a7a7;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist .nullwan{
        width: 74px;
        height: 29px;
        border-radius: 15px;
        border: solid 1px #ee9433;
        font-size: 14px;
        color: #ee9433;
        text-align: center;
        line-height: 29px;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist .editortext{
        width:67px;
        height: 29px;
        background-color: #3e99f2;
        border-radius: 15px;
        font-size: 14px;
        color: #fff;
        text-align: center;
        line-height: 29px;
        cursor: pointer;
        margin-left: 15px;
    }
    .planBoxs .planBoxcenter .planBoxcenterlist .chakan{
        font-size: 14px;
        color: #3e99f2;
        text-align: center;
        cursor: pointer;
    }
    .planBoxs .planBoxbottom{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .planBoxs .planBoxbottom .backtext{
        width: 80px;
        height: 26px;
        background-color: #3e99f2;
        border-radius: 5px;
        text-align: center;
        line-height: 26px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
    }
    .planBoxzhezhao .h-label.h-blueLabel{
        width: 1.2rem;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .message_box_alert {
      width: 750px !important;
    }
    .custom-alert {
        width: 1050px !important;
        height: 450px !important;
    }
    /* 1. 控制弹窗主体的宽度 */
    .big-image-alert {
        width: 1100px !important;      /* 必须加 !important 覆盖默认 max-width */
        max-width: none !important;    /* 清除最大宽度限制 */
        padding: 0;                    /* 清除外层 padding */
        margin: 0 auto;                /* 确保居中 */
    }

    /* 2. 控制图片容器，隐藏滚动条 */
    .big-image-alert .el-message-box__message {
        padding: 0;
        margin: 0;
        height: auto;     /* 高度自适应 */
        overflow: hidden; /* 彻底隐藏滚动条 */
    }

    /* 3. 图片样式：强制撑满 */
    .big-image-alert .el-message-box__message img {
        width: 1100px;    /* 固定宽度，或者使用 100% */
        height: 580px;    /* 固定高度 */
        display: block;
        object-fit: fill; /* 确保图片完全拉伸充满，不保持比例 */
    }
</style>
